import { AlertIcon, PendingIcon, UnlinkIcon } from "@codat/orchard-ui";
import React from "react";

import { ConnectionStatus } from "../Companies";

export const getConnectionLabelColor = (status: ConnectionStatus) => {
  switch (status) {
    case "PendingAuth":
      return "action";
    case "Unlinked":
      return "interface";
    case "Deauthorized":
      return "warning";
    default:
      return "positive";
  }
};

export const getConnectionIcon = (status: ConnectionStatus) => {
  switch (status) {
    case "PendingAuth":
      return <PendingIcon />;
    case "Deauthorized":
      return <AlertIcon />;
    case "Unlinked":
      return <UnlinkIcon />;
    default:
      return undefined;
  }
};

export const getConnectionInfoText = (status: ConnectionStatus) => {
  switch (status) {
    case "PendingAuth":
      return "This connection is pending authorization";
    case "Unlinked":
      return "This connection has been unlinked";
    default:
      return undefined;
  }
};

export const getConnectionTooltipText = (status: ConnectionStatus) => {
  switch (status) {
    case "Unlinked":
      return {
        header: "Connection unlinked",
        body: "This connection has been unlinked. This company needs to link their data again",
      };
    case "Deauthorized":
      return {
        header: "Connection no longer authorized",
        body: "This company needs to link their data again",
      };
    case "PendingAuth":
      return {
        header: "Connection not linked",
        body: "This company needs to link their data",
      };
    default:
      return undefined;
  }
};
